import { Controller } from "@hotwired/stimulus";

// A Fomantic modal that other elements on the page can open by key.
//
// Replaces an inline <script> that ran jQuery(...).modal() on turbo:load and
// hung window.openEditListModal off the global scope. Triggers now dispatch a
// `list-modal:open` event carrying a key; whichever modal claims that key
// shows itself. Nothing global, and it re-initialises on every Turbo visit.
//
//   %div{data: {controller: "list-modal", "list-modal-key-value" => "new"}}
//   %button{data: {action: "click->list-modal-opener#open",
//                  "list-modal-opener-key-value" => "new"}}
export default class extends Controller {
  static values = { key: String };

  connect() {
    if (window.jQuery) {
      window.jQuery(this.element).modal({
        duration: 50,
        observeChanges: true,
        centered: false,
        offset: 80,
      });
    }
    this._onOpen = (event) => {
      if (String(event.detail?.key) === this.keyValue) this.show();
    };
    document.addEventListener("list-modal-opener:open", this._onOpen);
  }

  disconnect() {
    document.removeEventListener("list-modal-opener:open", this._onOpen);
  }

  show() {
    if (window.jQuery) window.jQuery(this.element).modal("show");
  }
}
